import React from 'react';

type Props = {
  label?: string,
  id: string,
  onClickCheckbox: Function,
  isSelected: boolean,
  dataId: number,
};

/* eslint jsx-a11y/label-has-associated-control: ["error", { assert: "either" } ] */
function Checkbox(props: Props) {
  const { label, id, onClickCheckbox, isSelected, dataId } = props;
  return (
    <div data-automation-id={`checkbox-${dataId}`} className="checkbox-btn">
      <input
        className="checkbox-btn__input"
        type="checkbox"
        id={id}
        name={id}
        checked={isSelected}
        onChange={onClickCheckbox}
      />
      <label
        data-automation-id={`checkbox-label${dataId}`}
        className="checkbox-btn__label"
        htmlFor={id}
      >
        {label}
      </label>
    </div>
  );
}

Checkbox.defaultProps = {
  label: '',
};

export default Checkbox;
